<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='wms wms-otheroutstock' class='navbarbtn' v-if='showOtherOutStockPower'
        @click='showOtherOutStockDialogMD()'>
        其他出库
      </el-button>

      <el-button type='danger' icon='wms wms-otheroutstock' class='navbarbtn' v-if='showOtherBackStockPower'
        @click='showOtherBackStockDialogMD()'>
        其他退料
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.mesSourceBillNo' style='width: 125px;' placeholder='其他出库申请单号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :showOperationsColumn='true' operationColumnWidth='130px'
      :row-style='mainTableRowStyle'
      :expandRowKeys='mainTable.expandRowKeys'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <div v-if='scope.data.row.FROB === "1"'>
          <el-tooltip effect='dark' content='重新上传' placement='top-start' v-if='showReUploadOtherOutStockPower'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='uploadOtherOutStockBill(scope)'><i class='sys sys-uploaddocument'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletedOtherOutStockPower'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deletedOtherOutStockBill(scope)'><i class='sys sys-delete'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='单据明细' placement='top-start'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='showICStockBillEntryDialogMD(scope)'><i class='sys sys-record'></i>
            </el-button>
          </el-tooltip>
        </div>
        <div v-if='scope.data.row.FROB === "-1"'>
          <el-tooltip effect='dark' content='重新上传' placement='top-start' v-if='showReUploadOtherOutStockPower'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='uploadOtherOutStockBill(scope)'><i class='sys sys-uploaddocument'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletedOtherBackStockPower'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deletedOtherBackStockBill(scope)'><i class='sys sys-delete'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='单据明细' placement='top-start'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='showICStockBillEntryDialogMD(scope)'><i class='sys sys-record'></i>
            </el-button>
          </el-tooltip>
        </div>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 150px; text-align: left;'><span style='color: #42426F;'>仓库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>仓位代码</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>生成/采购日期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: left;'><span style='color: #42426F;'>保质期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>源单类型</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 180px; text-align: left;'><span style='color: #42426F;'>源单单号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: left;'><span style='color: #42426F;'>行号</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='wibe in scope.data.row.detailDt1'
            :key='wibe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{wibe.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{wibe.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{wibe.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{wibe.ItemModel}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{wibe.Qty}}{{wibe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 150px; text-align: left;'><span style='color: blue;'>{{wibe.SCStockName}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'><span style='color: blue;'>{{wibe.SCSPNumber}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: blue;'>{{wibe.BatchNo}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'>
              <span style='color: blue;'>
                {{!wibe.KFDate ? '' : dateTimeUtil.formartDateTime(new Date(wibe.KFDate), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 80px; text-align: left;'><span style='color: blue;'>{{wibe.KFPeriod}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span style='color: blue;'>{{showExpandTransformSpecialString('MESSourceType', wibe.MESSourceType)}} </span>
            </div>
            <div class='expand-row' style='min-width: 180px; text-align: left;'><span style='color: blue;'>{{wibe.MESSourceBillNo}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: left;'><span style='color: blue;'>{{wibe.MESSourceEntryID}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <!-- 其他出库 -->
    <el-dialog title='其他出库' :visible.sync='showOtherOutStockDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='sourceTranType' placeholder='请选择' :clearable='false'
          class='inputField-input' :disabled='sourceInterID.length > 0 || scanQRCodes.length > 0'
          @change='sourceTranTypeChange'
          style='width: 200px;' size='mini'>
          <el-option v-for='sourceTranType in sourceTranTypes'
            :key='sourceTranType.code' :label='sourceTranType.name' :value='sourceTranType.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left' v-if='sourceTranType === "WMS15"'>
          源单单号
        </div>
        <TableSelect v-model='sourceInterID' v-if='sourceTranType === "WMS15"' key='WMS_OtherOutRequest'
          class='inputField-input' ref='OtherOutRequestTableSelect'
          :displayValue='""'
          @change='sourceInterIDChange'
          returnCode='OtherOutRequestNo' displayCode='OtherOutRequestNo'
          customFilterStr=" AND Status IN ('1','2')"
          style='width: 200px;' tableCode='WMS_OtherOutRequest'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left' v-if='sourceTranType === "0"'>
          部门
        </div>
        <TableSelect v-model='icstockBillInfo.DeptID' v-if='sourceTranType === "0"' key='BD_Department'
          class='inputField-input' ref='DeptIDTableSelect'
          :displayValue='""'
          returnCode='DepartmentID' displayCode='Number' displayName='Name'
          customFilterStr=" AND Deleted IN ('0')"
          style='width: 200px;' tableCode='BD_Department'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='scanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          摘  要
        </div>
        <el-input v-model='icstockBillInfo.Explanation' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          发料人
        </div>
        <TableSelect v-model='icstockBillInfo.SManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
      </div>
      <div style='margin-top: 80px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备  注
        </div>
        <el-input v-model='icstockBillInfo.Remark' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          领料人
        </div>
        <TableSelect v-model='icstockBillInfo.FManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
      </div>
      <el-tabs v-model='activeTable'
        type='card' style='background: #fff; height: 100%; margin-top: 120px;'>
        <el-tab-pane label='源单信息' name='pickRQ'>
          <el-table :data='sourceEntrys' border :height='getScanQRCodesTableHeight()'
            ref='sourceEntrysTable' style='margin-top: 0px;'
            @row-dblclick='sourceEntrysTableDBLClick' :highlight-current-row='false'
            :cell-style='sourceEntrysTableCellStyle' row-key='GUID'
            :header-cell-style='mainTableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='EntryID' label='行号' width='60'>
            </el-table-column>
            <el-table-column prop='ItemNumber' label='物料代码' width='250'>
            </el-table-column>
            <el-table-column prop='ItemName' label='物料名称' width='200'>
            </el-table-column>
            <el-table-column prop='ItemModel' label='规格' width='200'>
            </el-table-column>
            <el-table-column prop='RequestQty' label='计划数量' width='100' align='right'>
            </el-table-column>
            <el-table-column prop='PickQty' label='已领数量' width='100' align='right'>
            </el-table-column>
            <el-table-column prop='Qty' label='本次可领数量' width='120' align='right'>
            </el-table-column>
            <el-table-column prop='UnitName' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='ScanQty' label='已扫码数量' width='120' align='right'>
            </el-table-column>
            <el-table-column prop='ScanPackageQty' label='已扫码包数' width='120' align='right'>
            </el-table-column>
            <el-table-column prop='InvQty' label='库存合计' width='100' align='right'>
            </el-table-column>
            <el-table-column prop='StockName' label='指定仓库' width='200'>
            </el-table-column>
            <el-table-column prop='RecommendStockPlaceNameStr' label='推荐仓库仓位' width='400'>
              <template #default='scope'>
                <pre style='margin: 0px; font-weight: bold;'>{{scope.row.RecommendStockPlaceNameStr}}</pre>
              </template>
            </el-table-column>
            <el-table-column label='操作' width='90' fixed='right'>
              <template #default='scope'>
                <el-button type='primary' circle style='padding: 4px;' size='mini'
                  @click='showInvDetailMD(scope.row)'><i class='wms wms-stock'></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label='已扫标签' name='qrCode'>
          <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
            ref='scanQRCodesTable' style='margin-top: 0px;'
            :cell-style='mainTableCellStyle' row-key='GUID'
            :header-cell-style='mainTableHeaderCellStyle' size='medium'>
            <el-table-column prop='EntryID' label='源单行号' width='60'>
            </el-table-column>
            <el-table-column prop='QRCode' label='标签号' width='200'>
            </el-table-column>
            <el-table-column prop='BI_Number' label='物料代码' width='300'>
            </el-table-column>
            <el-table-column prop='BI_Name' label='物料名称' width='350'>
            </el-table-column>
            <el-table-column prop='BI_Model' label='规格' width='200'>
            </el-table-column>
            <el-table-column prop='Qty' label='数量' width='60'>
            </el-table-column>
            <el-table-column prop='BU_Name' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='BatchNo' label='批号' width='100'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='100'>
            </el-table-column>
            <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
            </el-table-column>
            <el-table-column prop='ProducetItemID' label='产品专用号' width='200'>
            </el-table-column>
            <el-table-column label='操作' width='90' fixed='right'>
              <template #default='scope'>
                <el-button type='danger' circle style='padding: 4px;'
                  @click='deleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
                </el-button>
                <el-button type='primary' circle style='padding: 4px;'
                  @click='showCFDialogMD(scope.row)'><i class='sys sys-split'></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='otherOutStock()' size='mini'>其他出库</el-button>
        <el-button @click='showOtherOutStockDialog = false' size='mini'>取消</el-button>
      </div>

      <el-dialog v-dialogDrag title='标签拆分' :visible.sync='showCFDialog' width='330px' append-to-body
        top='10px' lock-scroll>
        <div style='margin-top: -30px;'>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            拆分数量
          </div>
          <el-input-number class='inputField-input' v-model='cfQty'
            size='mini' style='width: 200px;'>
          </el-input-number>
        </div>
        <div class='dialogButtomCenterBtn' style='margin-top: 40px;'>
          <el-button type='primary' @click='cf()' size='mini'>拆分</el-button>
          <el-button @click='showCFDialog = false' size='mini'>取消</el-button>
        </div>
      </el-dialog>

      <!-- 库存明细 -->
      <el-dialog v-dialogDrag title='库存' :visible.sync='showInvDetail' width='800px' append-to-body
        top='10px' lock-scroll>
        <el-table :data='invDetails' border height='300px'
          :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
          style='margin-top: -35px;' default-expand-all>
          <el-table-column type='index' label='序号' width='60'>
          </el-table-column>
          <el-table-column prop='StockName' label='仓库' width='160'>
          </el-table-column>
          <el-table-column prop='SPNumber' label='仓位代码' width='120'>
          </el-table-column>
          <el-table-column prop='BatchNo' label='批号' width='100'>
          </el-table-column>
          <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
          </el-table-column>
          <el-table-column prop='KFPeriod' label='保质期' width='100'>
          </el-table-column>
          <el-table-column prop='Qty' label='数量' width='80'>
          </el-table-column>
          <el-table-column prop='UnitName' label='单位' width='80'>
          </el-table-column>
          <el-table-column prop='ItemNumber' label='物料代码' width='300'>
          </el-table-column>
          <el-table-column prop='ItemName' label='物料名称' width='300'>
          </el-table-column>
          <el-table-column prop='ItemModel' label='规格型号' width='250'>
          </el-table-column>
          <el-table-column prop='ProducetItemID' label='专用产品号' width='250'>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-dialog>

    <!-- 其他出库单明细 -->
    <el-dialog v-dialogDrag title='其他出库单明细' :visible.sync='showICStockBillEntryDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='icStockBillEntry' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;' default-expand-all>
        <el-table-column type='expand' width='50'>
          <template #default='scope'>
            <div class='expand'>
              <div class='expand-inner'>
                <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
              </div>
            </div>
            <div class='expand' v-if='scope.row.Qty > 0'>
              <div v-for='(qrCode, qrCodeIndex) in scope.row.detailDt1'
                :key='qrCode.QRCode' class='expand-inner'>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'></span>{{qrCodeIndex + 1}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.QRCode}} </div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'></span>{{qrCode.Qty}}{{qrCode.BU_Name}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.OuterQRCode}} </div>
                <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.SupplyBatchNo}} </div>
              </div>
            </div>
            <div class='expand' v-if='scope.row.Qty < 0'>
              <div v-for='(qrCode, qrCodeIndex) in scope.row.detailDt2'
                :key='qrCode.QRCode' class='expand-inner'>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'></span>{{qrCodeIndex + 1}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.QRCode}} </div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'></span>{{qrCode.Qty}}{{qrCode.BU_Name}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.OuterQRCode}} </div>
                <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.SupplyBatchNo}} </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='300'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='规格型号' width='250'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='80'>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='80'>
        </el-table-column>
        <el-table-column prop='SCStockName' label='仓库' width='160'>
        </el-table-column>
        <el-table-column prop='SCSPNumber' label='仓位代码' width='120'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 其他退料 -->
    <el-dialog title='依申请其他退料' :visible.sync='showOtherBackStockDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='rqBackSourceTranType' placeholder='请扫描标签'
          class='inputField-input' disabled
          style='width: 200px;' size='mini'>
          <el-option
            key='WMS17' label='其他退料申请单' value='WMS17'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单单号
        </div>
        <TableSelect v-model='rqBackSourceInterID' key='WMS_OtherOutBackRequestEntry'
          class='inputField-input' ref='OtherBackRequestSourceInterIDTableSelect'
          :displayValue='""'
          @change='rqSourceInterIDChange' :disabled='scanQRCodes.length > 0'
          returnCode='OtherOutBackRequestNo' displayCode='OtherOutBackRequestNo' displayName='OtherOutBackRequestNo'
          customFilterStr=" AND Status IN ('1','2')"
          style='width: 200px;' tableCode='WMS_OtherOutBackRequestEntry'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='rqBackScanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          退回仓库
        </div>
        <el-select v-model='rqBackICStockBillInfo.DCStockID' placeholder='请选择'
          class='inputField-input' @change='rqDcstockChange'
          style='width: 200px;' size='mini'>
          <el-option v-for='stock in stocks'
            :key='stock.StockID' :label='stock.Name' :value='stock.StockID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          退回仓位
        </div>
        <TableSelect v-model='rqBackICStockBillInfo.DCSPID' ref='rqIcstockBillInfoDCSPIDTableSelect'
          class='inputField-input'
          :displayValue='""' :customFilterStr="' AND SPGroupID=\'' + dcstockTeam + '\''"
          returnCode='SPID' displayCode='Name'
          style='width: 200px;' tableCode='BD_StockPlace'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          发料人
        </div>
        <TableSelect v-model='rqBackICStockBillInfo.SManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
      </div>
      <div style='margin-top: 80px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          摘  要
        </div>
        <el-input v-model='rqBackICStockBillInfo.Explanation' size='mini' style='width: 200px;'
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备  注
        </div>
        <el-input v-model='rqBackICStockBillInfo.Note' size='mini' style='width: 200px;'
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          领料人
        </div>
        <TableSelect v-model='rqBackICStockBillInfo.FManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
      </div>
      <div style='margin-top: 120px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          物料代码
        </div>
        <el-input v-model='rqItemNumber' size='mini' style='width: 200px;' disabled
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          申请数量
        </div>
        <el-input v-model='rqQty' size='mini' style='width: 200px;' disabled
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          已退数量
        </div>
        <el-input v-model='rqBackQty' size='mini' style='width: 200px;' disabled
          class='inputField-input'>
        </el-input>
      </div>
      <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
        ref='backScanQRCodesTable' style='margin-top: 155px;'
        :cell-style='mainTableCellStyle' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column prop='QRCode' label='标签号' width='200'>
        </el-table-column>
        <el-table-column prop='BI_Number' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='BI_Name' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='BI_Model' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='60'>
        </el-table-column>
        <el-table-column prop='OutQty' label='本次退料数量' width='120'>
          <template #header>
            <span style='color: blue;'>本次退料数量</span>
          </template>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.OutQty'
              style='width: 100px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='BU_Name' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='ProducetItemID' label='产品专用号' width='200'>
        </el-table-column>
        <el-table-column label='操作' width='90' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='rqBackDeleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='rqBackItem()' size='mini'>退料</el-button>
        <el-button @click='showOtherBackStockDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import code from '@/components/sys/Code'
import power from '@/components/sys/Power'
import TableSelect from '@/components/custom/TableSelect.vue'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'OtherOutStock',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel,
    TableSelect: TableSelect
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_ICStockBill_OtherOut',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',
        mesSourceBillNo: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,

      showOtherOutStockDialog: false,
      sourceTranType: '',
      sourceTranTypes: [],
      sourceInterID: '',
      sourceEntrys: [],
      activeTable: 'pickRQ',
      scanEntryID: 0,
      scanQRCode: '',
      scanQRCodes: [],
      icstockBillInfo: {
        FManagerID: '',
        SManagerID: '',
        Explanation: '',
        DeptID: '',
        Remark: ''
      },
      tranTypes: [],

      showCFDialog: false,
      cfQty: 0,
      cfQRCode: '',
      cfRow: {},

      showInvDetail: false,
      invDetails: [],

      showICStockBillEntryDialog: false,
      icStockBillEntry: [],
      icStockBill: {},

      stocks: [],
      dcstockTeam: '',
      showOtherBackStockDialog: false,
      rqBackSourceTranType: 'WMS17',
      rqBackSourceInterID: '',
      rqBackSourceEntryID: 0,
      rq0BackSourceInterID: '',
      rq0BackSourceEntryID: 0,
      rqItemID: '',
      rqItemNumber: '',
      rqQty: '',
      rqBackQty: '',
      rqBackICStockBillInfo: {
        FManagerID: '',
        SManagerID: '',
        Explanation: '',
        Note: '',
        DCStockID: '',
        DCSPID: ''
      },

      showOtherOutStockPower: false,
      showReUploadOtherOutStockPower: false,
      showDeletedOtherOutStockPower: false,
      showOtherBackStockPower: false,
      showReUploadOtherBackStockPower: false,
      showDeletedOtherBackStockPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.sourceTranTypes = code.getCode(codes, 'WMS_TranType', ['0', 'WMS15'])
    that.tranTypes = code.getCode(codes, 'WMS_TranType')
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const stockObjPromise = table.getTableContent('BD_Stock', 10000, 1, '', " AND Deleted='0'")

    await tableContentPromise
    await tableFilterInfoPromise
    const stockObj = await stockObjPromise
    that.stocks = stockObj.tableContent
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.mesSourceBillNo) {
        const mesSourceBillNos = that.mainTable.mesSourceBillNo.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < mesSourceBillNos.length; i++) {
          detail1FilterStr += " OR MESSourceBillNo LIKE'%" + mesSourceBillNos[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.FROB === '-1') {
        if (data.row.HaveToErp === '0') {
          return { 'background-color': 'red', color: 'deeppink' }
        } else if (data.row.Status === '9') {
          return { 'background-color': '#CCCCCC', color: 'deeppink' }
        } else {
          return { color: 'deeppink' }
        }
      } else {
        if (data.row.HaveToErp === '0') {
          return { 'background-color': 'red' }
        } else if (data.row.Status === '9') {
          return { 'background-color': '#CCCCCC' }
        } else {
          return {}
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 其他出库弹出框显示方法
    showOtherOutStockDialogMD: function () {
      const that = this
      that.scanQRCodes = []
      that.sourceTranType = 'WMS15'
      that.sourceInterID = ''
      that.icstockBillInfo.DeptID = ''
      that.scanEntryID = 0
      that.sourceEntrys = []
      that.showOtherOutStockDialog = true
      if (that.$refs.OtherOutRequestTableSelect) {
        that.$refs.OtherOutRequestTableSelect.clearSelected()
      }
      if (that.$refs.DeptIDTableSelect) {
        that.$refs.DeptIDTableSelect.clearSelected()
      }
    },

    // 获取其他出库扫描标签表格高度
    getScanQRCodesTableHeight: function () {
      return window.innerHeight - 280 + 'px'
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 展开明细特征字符串转换方法
    showExpandTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'MESSourceType') {
        return table.specialStringDisplayTransform(val, that.tranTypes)
      }
      return val
    },

    // 源单类型改变方法
    sourceTranTypeChange: function () {
      const that = this
      that.sourceInterID = ''
      that.icstockBillInfo.DeptID = ''
      that.scanEntryID = 0
      that.sourceEntrys = []
      that.scanQRCode = ''
      that.scanQRCodes = []
      if (that.$refs.OtherOutRequestTableSelect) {
        that.$refs.OtherOutRequestTableSelect.clearSelected()
      }
      if (that.$refs.DeptIDTableSelect) {
        that.$refs.DeptIDTableSelect.clearSelected()
      }
    },

    // 源单表格行双击方法
    sourceEntrysTableDBLClick: function (row) {
      const that = this
      that.scanEntryID = row.EntryID
      if (that.$refs.sourceEntrysTable) {
        that.$refs.sourceEntrysTable.doLayout()
      }
    },

    // 源单表格单元格样式
    sourceEntrysTableCellStyle: function ({ row, column, rowIndex, columnIndex }) {
      const that = this
      if (row.EntryID === that.scanEntryID && (!column.property || column.property === 'EntryID')) {
        return { padding: '0px', 'background-color': 'orange' }
      }
      if (column.property && column.property !== 'EntryID') {
        if (row.ScanQty < row.Qty) {
          return { padding: '0px' }
        } else if (row.ScanQty === row.Qty) {
          return { padding: '0px', 'background-color': '#cccccc' }
        } else if (row.ScanQty > row.Qty) {
          return { padding: '0px', 'background-color': '#FF4500' }
        }
      }
      return { padding: '0px' }
    },

    // 源单改变方法
    sourceInterIDChange: async function (sourceRow) {
      const that = this
      if (!that.sourceInterID) {
        that.scanQRCodes = []
        that.scanEntryID = 0
        that.sourceEntrys = []
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.OtherOutStock.GetOtherOutRequestEntrys', {
        sourceTranType: that.sourceTranType,
        sourceInterID: that.sourceInterID
      })
      if (rtnObj.error === '000000') {
        that.sourceEntrys = rtnObj.data
        that.scanQRCodes = []
        that.scanEntryID = 0
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 扫码方法
    scanQRCodeEnterMD: async function () {
      const that = this
      if (!that.scanQRCode) {
        return
      }
      if (!that.sourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (that.sourceTranType !== '0' && !that.sourceInterID) {
        that.$message.error('请选择源单！')
        return
      }
      if (that.sourceTranType !== '0' && that.sourceEntrys.length <= 0) {
        that.$message.error('请选择源单！')
        return
      }
      if (that.sourceTranType !== '0' && that.scanEntryID === 0) {
        that.$message.error('请先双击选择需要扫码的源单物料！')
        return
      }
      let thisItemID = ''
      let thisStockID = ''
      for (let i = 0; i < that.sourceEntrys.length; i++) {
        if (that.sourceEntrys[i].EntryID === that.scanEntryID) {
          thisItemID = that.sourceEntrys[i].ItemID
          thisStockID = that.sourceEntrys[i].StockID ? that.sourceEntrys[i].StockID : ''
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (thisItemID && qrCodeObj.tableContent[i].ItemID !== thisItemID) {
            that.$message.error('该标签号的物料和源单上该行的物料不匹配！')
            loadingInstance.close()
            return
          }
          if (thisStockID && qrCodeObj.tableContent[i].StockID !== thisStockID) {
            that.$message.error('请选择已指定仓库的物料!')
            loadingInstance.close()
            return
          }
          if (qrCodeObj.tableContent[i].KFDate &&
              dateTimeUtil.addDateTime(new Date(qrCodeObj.tableContent[i].KFDate), 'DAY', qrCodeObj.tableContent[i].KFPeriod) <= new Date()) {
            that.$message.error('该标签号的物料已经过期，无法领用!')
            loadingInstance.close()
            return
          }
          if (qrCodeObj.tableContent[i].Status !== '1') {
            continue
          } else {
            let haveScanFlag = false
            for (let j = 0; j < that.scanQRCodes.length; j++) {
              if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                haveScanFlag = true
              }
            }
            if (haveScanFlag) {
              qrCodeObj.tableContent[i].haveScanFlag = true
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '1') {
            continue
          }
          if (qrCodeObj.tableContent[i].haveScanFlag) {
            addNum++
            continue
          }
          qrCodeObj.tableContent[i].EntryID = that.scanEntryID
          that.scanQRCodes.push(qrCodeObj.tableContent[i])
          that.scanQtyComputer()
          addNum++
        }
        that.scanQRCode = ''
        if (addNum <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号中的没有可以出库的内箱标签！')
          return
        }
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 删除已扫描
    deleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      that.scanQtyComputer()
    },

    // 已扫数量计算
    scanQtyComputer: function () {
      const that = this
      for (let i = 0; i < that.sourceEntrys.length; i++) {
        that.sourceEntrys[i].ScanQty = 0
        that.sourceEntrys[i].ScanPackageQty = 0
      }
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        for (let j = 0; j < that.sourceEntrys.length; j++) {
          if (that.sourceEntrys[j].EntryID === that.scanQRCodes[i].EntryID) {
            that.sourceEntrys[j].ScanQty += that.scanQRCodes[i].Qty
            that.sourceEntrys[j].ScanPackageQty++
            break
          }
        }
      }
      if (that.$refs.sourceEntrysTable) {
        that.$refs.sourceEntrysTable.doLayout()
      }
    },

    // 拆分弹出框显示方法
    showCFDialogMD: function (row) {
      const that = this
      that.showCFDialog = true
      that.cfQty = 0
      that.cfQRCode = row.QRCode
      that.cfRow = row
    },

    // 拆分
    cf: async function () {
      const that = this
      if (that.cfQty <= 0) {
        that.$message.error('拆分数量必须大于0！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.CFQRCode', {
        row: that.cfRow,
        cfQty: that.cfQty
      })
      if (rtnObj.error === '000000') {
        that.cfRow.Qty = that.cfQty
        that.cfRow.QRCode = that.cfRow.QRCode + 'a'
        that.scanQtyComputer()
        that.showCFDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 库存明细弹出框显示方法
    showInvDetailMD: function (row) {
      const that = this
      that.showInvDetail = true
      that.invDetails = row.AllStockPlaceNames
    },

    // 其他出库
    otherOutStock: async function () {
      const that = this
      if (!that.sourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (that.sourceTranType !== '0' && !that.sourceInterID) {
        that.$message.error('请选择源单！')
        return
      }
      if (that.sourceTranType !== '0' && that.sourceEntrys.length <= 0) {
        that.$message.error('请选择源单！')
        return
      }
      if (that.sourceTranType === '0' && !that.icstockBillInfo.DeptID) {
        that.$message.error('请选择部门！')
        return
      }
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.OtherOutStock.CreateOtherOutStock', {
        sourceTranType: that.sourceTranType,
        sourceInterID: that.sourceInterID,
        scanQRCodes: that.scanQRCodes,
        icstockBillInfo: that.icstockBillInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showOtherOutStockDialog = false
        if (rtnObj.msg) {
          that.$message.warning('出库成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('出库成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 重新上传其他出库单至金蝶
    uploadOtherOutStockBill: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/UploadToERP.UploadICStockBill.UploadICStockBill29', {
        billNo: scope.data.row.BillNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('重新上传成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除其他出库单
    deletedOtherOutStockBill: async function (scope) {
      const that = this
      that.$confirm('确定要删除该其他出库单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.OtherOutStock.DeleteOtherOutStock', {
          billNo: scope.data.row.BillNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 其他出库单明细显示方法
    showICStockBillEntryDialogMD: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const icStockBillEntryObj = await table.getTableContent('WMS_ICStockBillEntry_OtherOut'
        , 10000, 1, ' EntryID ASC', " AND BillNo='" + scope.data.row.BillNo + "'")
      if (icStockBillEntryObj.error === '000000') {
        that.icStockBillEntry = icStockBillEntryObj.tableContent
        that.icStockBill = scope.data.row
        that.showICStockBillEntryDialog = true
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 依单退料弹出框显示方法
    showOtherBackStockDialogMD: function () {
      const that = this
      that.scanQRCodes = []
      that.rqBackSourceTranType = 'WMS17'
      that.rqBackSourceInterID = ''
      that.rqBackSourceEntryID = 0
      that.rq0BackSourceInterID = ''
      that.rq0BackSourceEntryID = 0
      if (that.$refs.OtherBackRequestSourceInterIDTableSelect) {
        that.$refs.OtherBackRequestSourceInterIDTableSelect.clearSelected()
      }
      that.showOtherBackStockDialog = true
      that.rqBackICStockBillInfo.Explanation = ''
      that.rqBackICStockBillInfo.Note = ''
    },

    // 依单退料仓库选择方法
    rqDcstockChange: function () {
      const that = this
      if (that.$refs.rqIcstockBillInfoDCSPIDTableSelect) {
        that.$refs.rqIcstockBillInfoDCSPIDTableSelect.clearSelected()
      }
      for (let i = 0; i < that.stocks.length; i++) {
        if (that.stocks[i].StockID === that.rqBackICStockBillInfo.DCStockID) {
          that.dcstockTeam = that.stocks[i].SPGroupID
          break
        }
      }
    },

    // 依单退料申请源单选择方法
    rqSourceInterIDChange: function (sourceRow) {
      const that = this
      that.rqBackSourceInterID = sourceRow.OtherOutBackRequestNo
      that.rqBackSourceEntryID = sourceRow.EntryID
      that.rqItemID = sourceRow.ItemID
      that.rqItemNumber = sourceRow.ItemNumber
      that.rqQty = sourceRow.Qty
      that.rqBackQty = sourceRow.BackQty
      that.rqBackSourceTranType = 'WMS17'
    },

    // 依单退料扫码方法
    rqBackScanQRCodeEnterMD: async function () {
      const that = this
      if (!that.scanQRCode) {
        return
      }
      if (!that.rqBackSourceInterID) {
        that.$message.error('请先选择源单！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].ItemID !== that.rqItemID) {
            that.$message.error('该标签号的物料和源单上该行的物料不匹配！')
            loadingInstance.close()
            return
          }
          if (qrCodeObj.tableContent[i].Status !== '2') {
            continue
          } else if (qrCodeObj.tableContent[i].OutStockTranType !== '29') {
            continue
          } else {
            if (that.rq0BackSourceInterID &&
              (qrCodeObj.tableContent[i].OutStockBillInterID !== that.rq0BackSourceInterID ||
              qrCodeObj.tableContent[i].OutStockEntryID !== that.rq0BackSourceEntryID)) {
              loadingInstance.close()
              that.$message.error('不同其他出库的标签无法一起其他退料！')
              return
            }

            qrCodeObj.tableContent[i].OutQty = qrCodeObj.tableContent[i].Qty
            let haveScanFlag = false
            for (let j = 0; j < that.scanQRCodes.length; j++) {
              if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                haveScanFlag = true
              }
            }
            if (haveScanFlag) {
              qrCodeObj.tableContent[i].haveScanFlag = true
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '2') {
            continue
          } else if (qrCodeObj.tableContent[i].OutStockTranType !== '29') {
            continue
          }
          if (qrCodeObj.tableContent[i].haveScanFlag) {
            addNum++
            continue
          }
          if (!that.rq0BackSourceInterID) {
            that.rq0BackSourceInterID = qrCodeObj.tableContent[i].OutStockBillInterID
            that.rq0BackSourceEntryID = qrCodeObj.tableContent[i].OutStockEntryID
          }
          that.scanQRCodes.push(qrCodeObj.tableContent[i])
          addNum++
        }
        that.scanQRCode = ''
        if (addNum <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号中的没有可以其他退料的内箱标签！')
          return
        }
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 依单退料删除已扫描
    rqBackDeleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      if (that.scanQRCodes.length === 0) {
        that.rq0BackSourceInterID = ''
        that.rq0BackSourceEntryID = 0
      }
    },

    // 依单退料
    rqBackItem: async function () {
      const that = this
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码')
        return
      }
      if (!that.rqBackICStockBillInfo.DCStockID) {
        that.$message.error('请选择退回仓库！')
        return
      }
      if (!that.rqBackICStockBillInfo.DCSPID) {
        that.$message.error('请选择退回仓位！')
        return
      }
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      for (let i = 0; i < that.scanQRCodes.length; i++) {
        if (!numberReg.test(that.scanQRCodes[i].OutQty)) {
          that.$message.error('本次退料数量必须为大于0的数字！')
          return
        }
        if (parseFloat(that.scanQRCodes[i].OutQty) <= 0) {
          that.$message.error('本次退料数量必须为大于0的数字！')
          return
        }
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.OtherOutStock.RQOtherBackItem', {
        rqSourceTranType: that.rqBackSourceTranType,
        rqSourceInterID: that.rqBackSourceInterID,
        rqSourceEntryID: that.rqBackSourceEntryID,
        rq0SourceInterID: that.rq0BackSourceInterID,
        rq0SourceEntryID: that.rq0BackSourceEntryID,
        scanQRCodes: that.scanQRCodes,
        icstockBillInfo: that.rqBackICStockBillInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showOtherBackStockDialog = false
        if (rtnObj.msg) {
          that.$message.warning('其他退料成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('其他退料成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除其他退料单
    deletedOtherBackStockBill: async function (scope) {
      const that = this
      that.$confirm('确定要删除该其他退料单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.OtherOutStock.DeleteOtherBackStock', {
          billNo: scope.data.row.BillNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
